module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/painel/painel.component.css
// module id = ./src/app/painel/painel.component.css
// module chunks = main